import { useQuery } from '@tanstack/react-query'
import { keys } from '@/api/hooks/shared/keys'
import { loadBetfairRatesLogs } from './betfairRatesData'
import type { BetfairRatesLogQuery } from './betfairRatesTypes'

/** BetfairRates Logs — live Keycloak → Agent-API `getBetfairRatesLogs`. */
export function useBetfairRatesLogs(query: BetfairRatesLogQuery) {
  return useQuery({
    queryKey: keys.betfairRatesLogs(query),
    queryFn: () => loadBetfairRatesLogs(query),
    placeholderData: (previous) => previous,
    retry: false,
  })
}
